import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { class: "-my-3.5" }
const _hoisted_2 = {
  key: 0,
  class: "-my-3.5"
}
const _hoisted_3 = {
  key: 1,
  "data-cart-builder": "",
  class: "flex flex-col gap-3"
}
const _hoisted_4 = ["disabled", "onClick"]
const _hoisted_5 = {
  key: 0,
  class: "divide-y divide-[#eef0f3] rounded-lg border border-gray-200"
}
const _hoisted_6 = { class: "min-w-0 flex-1 truncate text-sm text-gray-900" }
const _hoisted_7 = ["aria-label", "onClick"]
const _hoisted_8 = {
  key: 1,
  class: "m-0 text-sm text-gray-500"
}

import { MenuItem } from '@headlessui/vue'
import { computed, ref } from 'vue'

import InlineSearchSelect from '@/components/InlineSearchSelect.vue'
import AutoChargeConfirmModal from '@/components/neue/AutoChargeConfirmModal.vue'
import NumberStepper from '@/components/neue/wizard/NumberStepper.vue'
import SelectionCard from '@/components/neue/wizard/SelectionCard.vue'
import SelectionGroup from '@/components/neue/wizard/SelectionGroup.vue'
import ToggleRow from '@/components/neue/wizard/ToggleRow.vue'
import WizardIcon from '@/components/neue/wizard/WizardIcon.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { AUTOFILL_KINDS, sectionCopy } from '@/config/dropWizardSteps'
import { mapRelationship } from '@/store/mappers'


export default {
  __name: 'StepPay',
  props: { recipientRows: { type: Array, default: () => [] } },
  setup(__props) {


const wizard = injectWizard()
const payment = computed(() => wizard.data.payment)
const confirming = ref(false)
const productQuery = ref('')
const productResults = ref([])

// Only products sold in the chosen store can go in its drop's cart.
const storeProducts = products =>
  products.filter(product =>
    (product.relationships?.category_product_store_pairs?.data ?? []).some(
      ref => String(mapRelationship(ref)?.attributes?.store_id) === String(wizard.data.storeId)
    )
  )

const hasCartItem = productId => payment.value.cartItems.some(item => item.productId === String(productId))

const addCartItem = product => {
  if (hasCartItem(product.id)) return
  payment.value.cartItems.push({ productId: String(product.id), name: product.attributes.product_name, quantity: 1 })
  productQuery.value = ''
  productResults.value = []
}

const removeCartItem = productId => {
  payment.value.cartItems = payment.value.cartItems.filter(item => item.productId !== productId)
}

const askAutocharge = () => {
  if (payment.value.autocharge === true) return
  confirming.value = true
}

const confirmAutocharge = () => {
  payment.value.autocharge = true
  confirming.value = false
}

const cancelAutocharge = () => {
  confirming.value = false
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(WizardSection, _mergeProps(_unref(sectionCopy)('payment', _unref(wizard).data), { plain: "" }), {
      default: _withCtx(() => [
        _createVNode(SelectionGroup, { label: "Payment" }, {
          default: _withCtx(({ groupName }) => [
            _createVNode(SelectionCard, {
              name: groupName,
              icon: "card",
              title: "Charge saved carts automatically",
              subtitle: "At the cutoff, every cart with a card on file is charged and the customer gets a receipt by text. Empty carts are filled from the customer's last order first.",
              chip: "Autocharge",
              selected: payment.value.autocharge === true,
              onSelect: askAutocharge
            }, null, 8, ["name", "selected"]),
            _createVNode(SelectionCard, {
              name: groupName,
              icon: "banknote",
              title: "Customers check out themselves",
              subtitle: "Carts stay open until the customer pays.",
              selected: payment.value.autocharge === false,
              onSelect: _cache[0] || (_cache[0] = $event => (payment.value.autocharge = false))
            }, null, 8, ["name", "selected"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 16),
    _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(_unref(sectionCopy)('carts', _unref(wizard).data))), {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(ToggleRow, {
            modelValue: payment.value.autofill,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((payment.value.autofill) = $event)),
            title: "Fill carts before reminding",
            description: "Customers open their reminder with a cart already filled. They can change it."
          }, null, 8, ["modelValue"])
        ]),
        (payment.value.autofill)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(SelectionGroup, { label: "What fills the cart" }, {
                default: _withCtx(({ groupName }) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(AUTOFILL_KINDS), (kind) => {
                    return (_openBlock(), _createBlock(SelectionCard, {
                      key: kind.value,
                      compact: "",
                      name: groupName,
                      title: kind.title,
                      subtitle: kind.subtitle,
                      selected: payment.value.autofillKind === kind.value,
                      onSelect: $event => (payment.value.autofillKind = kind.value)
                    }, null, 8, ["name", "title", "subtitle", "selected", "onSelect"]))
                  }), 128))
                ]),
                _: 1
              }),
              (payment.value.autofillKind !== 'cart')
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(ToggleRow, {
                      modelValue: payment.value.autofillTip,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((payment.value.autofillTip) = $event)),
                      title: "Carry over last time's tip",
                      description: "The tip from the customer's last order is added to the new one."
                    }, null, 8, ["modelValue"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(InlineSearchSelect, {
                      position: "relative",
                      "helper-text": { typingPrompt: 'Search your products', noResult: 'No products found' },
                      "search-endpoint": "products/search?included=category_product_store_pairs",
                      "search-request": { query: productQuery.value },
                      onOnSearch: _cache[3] || (_cache[3] = $event => (productQuery.value = $event)),
                      onOnResults: _cache[4] || (_cache[4] = $event => (productResults.value = storeProducts($event)))
                    }, {
                      searchResults: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productResults.value, (item) => {
                          return (_openBlock(), _createBlock(_unref(MenuItem), {
                            key: item.id
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                type: "button",
                                class: "group w-full rounded-md px-2 py-2 text-left text-sm text-gray-700 transition-colors duration-200 hover:bg-gray-100 disabled:text-gray-300",
                                disabled: hasCartItem(item.id),
                                onClick: $event => (addCartItem(item))
                              }, _toDisplayString(item.attributes.product_name), 9, _hoisted_4)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["search-request"]),
                    (payment.value.cartItems.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payment.value.cartItems, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.productId,
                              "data-cart-item": "",
                              class: "flex items-center gap-3 px-3 py-2"
                            }, [
                              _createElementVNode("span", _hoisted_6, _toDisplayString(item.name), 1),
                              _createVNode(NumberStepper, {
                                "model-value": item.quantity,
                                name: "Quantity",
                                min: 1,
                                "onUpdate:modelValue": $event => (item.quantity = $event ?? 1)
                              }, null, 8, ["model-value", "onUpdate:modelValue"]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "rounded-md p-1 text-gray-400 hover:bg-red-50 hover:text-red-600",
                                "aria-label": `Remove ${item.name}`,
                                onClick: $event => (removeCartItem(item.productId))
                              }, [
                                _createVNode(WizardIcon, { name: "x" })
                              ], 8, _hoisted_7)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_8, " No products yet. Search above to add the items every customer starts with. "))
                  ]))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16),
    _createVNode(AutoChargeConfirmModal, {
      "is-open": confirming.value,
      audiences: __props.recipientRows,
      onConfirm: confirmAutocharge,
      onCancel: cancelAutocharge
    }, null, 8, ["is-open", "audiences"])
  ], 64))
}
}

}